import { useContext, createContext } from 'react';
import type { TrackingServiceContextState } from './ContentInterfaces';

export const TrackingServiceContext = createContext<Partial<TrackingServiceContextState>>({});

export const useTrackingService = () => useContext(TrackingServiceContext);
